import { MoveFlow, Language } from '@boltenergy-be/shared'
import { AddressWithCountryAndTownCode } from 'types/general.ts'

export type AppStore = {
  betaMode: boolean
  storeLoaded: boolean // Set to true once redux-remember has rehydrated the persisted state
  language: Language
  redirect: string | null
  showAllAddresses: boolean
  salesSurvey: {
    contractId: string | null
    show: 'intro' | 'modal' | false
    isEligible: boolean // Indicates if the user is eligible to see the sales survey
  }
  error: string | null
  urlSearchParams: {
    [key in UrlSearchParamsKeys]?: string
  }
  move: {
    flow: MoveFlow
    started?: MoveFlowState
    stopped?: MoveFlowState
  }
}

export type MoveFlowState = {
  address: AddressWithCountryAndTownCode
  date: string | null // ISO
}

export type SetMoveFlowStatePayload = {
  key: keyof Omit<AppStore['move'], 'flow'>
  state: MoveFlowState
}

// ENUMS

export enum LanguageLowercase {
  NL = 'nl',
  FR = 'fr'
}

export enum UrlSearchParamsKeys {
  CONTACT_ID = 'contact_id',
  CUSTOMER_EMAIL = 'customer_email',
  BILLING_CONTRACT_NUMBER = 'billing_contract_number',
  PROPOSED_INSTALMENT = 'proposed_instalment',
  CUSTOMER_ID = 'customerId', // Same as POM implementation
  FIXED_PRICE_RENEWAL_CONFIRMATION = 'fixed_price_renewal_confirmation',
  FAQ_CATEGORY = 'faq_category',
  POSTHOG_DISTINCT_ID = 'ph_distinct_id', // Posthog distinct ID
  POSTHOG_SESSION_ID = 'ph_session_id' // Posthog session ID
}
